export const environment = {
  production: true,
  apiKey: "AIzaSyAXES19Uf4o8Ujt3X9skWqfhylK7LNai_s",
  authDomain: "homecodec-cce50.firebaseapp.com",
  databaseURL: "https://homecodec-cce50.firebaseio.com",
  projectId: "homecodec-cce50",
  storageBucket: "homecodec-cce50.appspot.com",
  messagingSenderId: "650992398167",
  appId: "1:650992398167:web:4ae0042267437085"
};